export class AisRequisitionAccountResponseDto {
  account: string;
}

export class AisRequisitionResponseDto {
  id: number;
  businessEntityId: number;
  providerId: number;
  institutionId: number;
  agreementId?: number;
  code: string;
  redirect: string;
  status: string;
  agreement: string;
  reference: string;
  userLanguage: string;
  link: string;
  ssn: string;
  accountSelection: boolean;
  redirectImmediate: boolean;
  accounts: AisRequisitionAccountResponseDto[];
  maxHistoricalDays?: number;
  accessValidForDays: number;
  accessDisabledDate?: Date;
  isWithdrawalAccount?: boolean;
}
